// NOTE: The available characters are found at
// https://stackoverflow.com/questions/26088849/url-fragment-allowed-characters
export const URL_HASH_PREFIX_ENCODED_APPDATA = "!";
//# sourceMappingURL=consts.js.map